import Vue from 'vue';
import {store} from './../../plugins/vuex/index'
import _ from "lodash";

function isSettingEnabled(settingStr) {
  if (!settingStr || !store) {
    return true;
  }

  if (typeof settingStr === 'string') {
    return store.state.global[settingStr]
  }

  let settings = _.cloneDeep(settingStr)
  const method = settings.shift()

  if (settings.length === 0) {
    return false
  }

  if (method === 'OR') {
    for (const str of settings) {
      if (isSettingEnabled(str)) {
        return true
      }
    }
    return false
  } else if (method === 'AND') {
    for (const str of settings) {
      if (!isSettingEnabled(str)) {
        return false
      }
    }
    return true
  }

  return false;
}

function checkSettingForTrue(el, binding) {
  if (binding.value) {
    let allowed = isSettingEnabled(binding.value);
    el.style.display = !allowed ? 'none' : '';
  }
}

function checkSettingForFalse(el, binding) {
  if (binding.value) {
    let allowed = !isSettingEnabled(binding.value);
    el.style.display = !allowed ? 'none' : '';
  }
}

Vue.directive('setting-enabled', {
  inserted: checkSettingForTrue,
  updated: checkSettingForTrue,
  componentUpdated: checkSettingForTrue
});

Vue.directive('setting-not-enabled', {
  inserted: checkSettingForFalse,
  updated: checkSettingForFalse,
  componentUpdated: checkSettingForFalse
});

export {
  isSettingEnabled
}
